export default [
  {
    path: '/friends',
    name: 'UserMyOrders',
    component: () => import('@/views/app-user/my-orders/order-list/OrderList.vue'),
    meta: {
      pageTitle: 'My Orders',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'My Orders',
          active: true,
        },
      ],
    },
  },
  {
    path: '/friends/login',
    name: 'Login',
    component: () => import('@/views/app-user/auth/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/friends/account-setting',
    name: 'UserAccountSetting',
    component: () => import('@/views/app-user/my-account/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account Settings',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'My Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/friends/account-setting/change-email',
    name: 'UserAccountSettingChangeEmail',
    component: () => import('@/views/app-user/my-account/account-setting/AccountSettingGeneralChangeEmail.vue'),
    meta: {
      pageTitle: 'Change Email',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'My Account',
          to: { name: 'UserAccountSetting'},
        },
        {
          text: 'Change Email',
          active: true,
        },
      ],
    },
  },
  {
    path: '/friends/account-setting/change-cell',
    name: 'UserAccountSettingChangeCell',
    component: () => import('@/views/app-user/my-account/account-setting/AccountSettingGeneralChangeCell.vue'),
    meta: {
      pageTitle: 'Change Phone Number',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'My Account',
          to: { name: 'UserAccountSetting'},
        },
        {
          text: 'Change Phone Number',
          active: true,
        },
      ],
    },
  },
  {
    path: '/friends/my-invoices',
    name: 'UserMyInvoices',
    component: () => import('@/views/app-user/my-invoices/invoice-list/InvoiceList.vue'),
    meta: {
      pageTitle: 'My Invoices',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'My Invoices',
          active: true,
        },
      ],
    },
  },
  {
    path: '/friends/sub-accounts',
    name: 'SubAccounts',
    component: () => import('@/views/app-user/sub-accounts/SubAccounts.vue'),
    meta: {
      pageTitle: 'Sub Accounts',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'Sub Accounts',
          active: true,
        },
      ],
    },
  },
  {
    path: '/friends/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/app-user/auth/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/friends/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('@/views/app-user/auth/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/friends/login-with-otp',
    name: 'LoginWithOTP',
    component: () => import('@/views/app-user/auth/LoginWithOtp.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/friends/login-with-hash/',
    name: 'LoginWithHash',
    component: () => import('@/views/app-user/auth/LoginWithHash.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/friends/friend-orders/',
    name: 'ViewOrderWithHash',
    component: () => import('@/views/app-user/my-orders/order-with-hash/ViewOrderWithHash.vue'),
    meta: {
      pageTitle: 'Friend\'s Orders',
      canaccess: 'USER',
      breadcrumb: [
        {
          text: 'Friend\'s Orders',
          active: true,
        },
      ],
    },
  },
]